<template>
  <div style="margin:20px">
    <FiPageRail title="Process Manager" />

    <b-button size="sm" @click="disable_all()">Disable All</b-button>&nbsp;
    &nbsp;&nbsp;
    <b-button size="sm" @click="enable_all()">Enable All</b-button>&nbsp;
    <br/><br/>
    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="prev_run_time" slot-scope="row">
          {{row.item.prev_run_time | formatDateTime}}
        </template>

        <template slot="last_run_time" slot-scope="row">
          {{row.item.last_run_time | formatDateTime}}
        </template>

        <template slot="enabled" slot-scope="row">
          <b-form-select v-model="row.item.enabled" :options="enabled_options" @change="update_process_enabled(row.item)"/>
        </template>

        <template slot="actions" slot-scope="row">
            <b-button size="sm" @click="delete_process_record(row.item)">Delete</b-button>&nbsp;
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import {get_process_manager_list, delete_user, update_process_enabled, delete_process_record, disable_all_processes, enable_all_processes} from '../networking/apis'
    import {mapState} from "vuex";

    export default {
      name: 'process_manager_list',
      components: {
      },

      data() {
        return {
          msg: 'users',
          items: [],
          summary: [],
          loading: true,
          totalRows: 1,
          currentPage: 1,
          perPage: 100,
          pages: [],
          enabled_options: [
            { value: 'true', text: 'Enabled' },
            { value: 'false', text: 'Disabled' },
          ],
          fields: [
            { key: 'tenant_name', label: 'Tenant', sortable: true},
            { key: 'process_id', label: 'Process ID', sortable: true},
            { key: 'prev_run_time', label: 'Previous Run Time', sortable: true},
            { key: 'last_run_time', label: 'Last Run Time', sortable: true},
            { key: 'enabled', label: 'Enabled', sortable: true},
            { key: 'actions', label: '', sortable: true},
          ],
        }
      },

      async created() {
        await this.load_data()
      },
      methods: {
        async disable_all() {
          this.$emit('showAlert', "disabling all processes", 'info')
          const {value: { data = [] } } = await disable_all_processes()
          this.$emit('showAlert', "finished disabling all processes", 'success', 10000)
          await this.load_data()
        },
        async enable_all() {
          this.$emit('showAlert', "enabling all processes", 'info')
          const {value: { data = [] } } = await enable_all_processes()
          this.$emit('showAlert', "finished enabling all processes", 'success', 10000)
          await this.load_data()
        },

        async update_process_enabled(item) {
          const {value: { data = [] } } = await update_process_enabled(item.tenant_id, item.process_id, item.enabled)
        },
        async delete_process_record(item) {
          this.$emit('showAlert', "deleting process record: " + item.tenant_id + " - " + item.process_id, 'info')
          const {value: { data = [] } } = await delete_process_record(item.tenant_id, item.process_id)
          this.$emit('showAlert', "process record: " + item.tenant_id + " - " + item.process_id + " has been deleted", 'success', 10000)
          await this.load_data()
        },
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_process_manager_list('')
            this.items = data
          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }

          this.loading = false
        },
        async delete_user(username) {
          this.$emit('showAlert', "deleting User..." + username, 'info')
          const result = await delete_user(this.user.tenant,username)
          this.$emit('showAlert', "user " + username + " has been deleted", 'success', 5000)
          await this.load_data()
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        }
      }
    }
</script>

<style>

  .error td { background-color: rgba(255,0,0,0.25)}
  .success td {background-color: hsla(120,100%,75%,0.3)}
  .unprocessed td { background-color: hsla(200,40%,80%,0.3) }
  .cancelled td { background-color: hsla(290,60%,70%,0.3) }

  div.row:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .header {
    font-weight: bold;
  }

  div.col {
    border: 1px solid grey;
  }

  .table td {
    padding: .1rem !important;
  }

  .list-text {
    text-align: left;
    margin-top: 7px;
    margin-left: 7px;
  }

  .list-option {
    text-align: left;
    margin: 2px;
  }
</style>

